import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_divider = _resolveComponent("van-divider");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_form = _resolveComponent("van-form");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_CodeDataPickerCpt = _resolveComponent("CodeDataPickerCpt");
  const _component_DataPickerCpt = _resolveComponent("DataPickerCpt");
  const _component_AddrDataPickerCpt = _resolveComponent("AddrDataPickerCpt");
  const _component_PopupDatePickerCpt = _resolveComponent("PopupDatePickerCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, null, {
    footer: _withCtx(() => [_createVNode(_component_van_row, null, {
      default: _withCtx(() => [_createVNode(_component_van_col, {
        span: $data.detail ? 8 : 24
      }, {
        default: _withCtx(() => [_createVNode(_component_van_button, {
          style: {
            "width": "100%"
          },
          type: "primary",
          loading: $data.btnLoading,
          onClick: $options.onSaveClick
        }, {
          default: _withCtx(() => [_createTextVNode(" 保存 ")]),
          _: 1
        }, 8, ["loading", "onClick"])]),
        _: 1
      }, 8, ["span"]), $data.detail ? (_openBlock(), _createBlock(_component_van_col, {
        key: 0,
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_van_button, {
          plain: "",
          style: {
            "width": "100%"
          },
          type: "primary",
          onClick: _withModifiers($options.onToVisitRecord, ["prevent"])
        }, {
          default: _withCtx(() => [_createTextVNode(" 拜访记录 ")]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })) : _createCommentVNode("", true), $data.detail ? (_openBlock(), _createBlock(_component_van_col, {
        key: 1,
        span: 8
      }, {
        default: _withCtx(() => [_createVNode(_component_van_button, {
          plain: "",
          style: {
            "width": "100%"
          },
          type: "primary",
          onClick: _withModifiers($options.onToInvestRecord, ["prevent"])
        }, {
          default: _withCtx(() => [_createTextVNode(" 投资记录 ")]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })) : _createCommentVNode("", true)]),
      _: 1
    })]),
    default: _withCtx(() => [_createVNode(_component_van_form, {
      ref: "form",
      onSubmit: $options.onSubmit
    }, {
      default: _withCtx(() => [_createVNode(_component_van_cell_group, {
        title: "基本信息"
      }, {
        default: _withCtx(() => [_createVNode(_component_van_field, {
          modelValue: $data.form.chnName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.chnName = $event),
          required: "",
          name: "chnName",
          label: "客户姓名",
          placeholder: "客户姓名",
          disabled: $data.isDisabled,
          rules: [{
            required: true,
            message: '请输入客户姓名'
          }]
        }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_van_field, {
          modelValue: $data.form.idType.text,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.idType.text = $event),
          readonly: "",
          name: "idType",
          label: "证件类型",
          placeholder: "证件类型",
          disabled: $data.isDisabled,
          clickable: !$data.isDisabled,
          rightIcon: $options.getRightIcon('idType'),
          onClickInput: _cache[2] || (_cache[2] = $event => $options.onPickerSelectClick('idType')),
          onClickRightIcon: _cache[3] || (_cache[3] = $event => $options.onRightIconClick('idType'))
        }, null, 8, ["modelValue", "disabled", "clickable", "rightIcon"]), _createVNode(_component_van_field, {
          modelValue: $data.form.idNo,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.idNo = $event),
          name: "idNo",
          label: "证件号码",
          placeholder: "证件号码",
          disabled: $data.isDisabled
        }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_van_field, {
          modelValue: $data.form.idEndDate,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.idEndDate = $event),
          readonly: "",
          clickable: "",
          name: "idEndDate",
          label: "证件有效期",
          placeholder: "证件有效期",
          rightIcon: $options.getRightIcon('idEndDate'),
          onClickInput: _cache[6] || (_cache[6] = $event => $options.onPopupDateTimeSelectClick('idEndDate')),
          onClickRightIcon: _cache[7] || (_cache[7] = $event => $options.onRightIconClick('idEndDate'))
        }, null, 8, ["modelValue", "rightIcon"]), _createVNode(_component_van_field, {
          modelValue: $data.form.sex.text,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.sex.text = $event),
          readonly: "",
          name: "sex",
          label: "性别",
          placeholder: "性别",
          disabled: $data.isDisabled,
          clickable: !$data.isDisabled,
          rightIcon: $options.getRightIcon('sex'),
          onClickInput: _cache[9] || (_cache[9] = $event => $options.onPickerSelectClick('sex')),
          onClickRightIcon: _cache[10] || (_cache[10] = $event => $options.onRightIconClick('sex'))
        }, null, 8, ["modelValue", "disabled", "clickable", "rightIcon"]), _createVNode(_component_van_field, {
          modelValue: $data.form.birthday,
          "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.form.birthday = $event),
          readonly: "",
          name: "birthday",
          label: "出生日期",
          placeholder: "出生日期",
          disabled: $data.isDisabled,
          clickable: !$data.isDisabled,
          rightIcon: $options.getRightIcon('birthday'),
          onClickInput: _cache[12] || (_cache[12] = $event => $options.onPopupDateTimeSelectClick('birthday')),
          onClickRightIcon: _cache[13] || (_cache[13] = $event => $options.onRightIconClick('birthday'))
        }, null, 8, ["modelValue", "disabled", "clickable", "rightIcon"]), _createVNode(_component_van_field, {
          modelValue: $data.form.mobile,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.form.mobile = $event),
          required: "",
          name: "mobile",
          label: "手机号码",
          placeholder: "手机号码",
          disabled: $data.isDisabled,
          rules: [{
            required: true,
            message: '请输入手机号码'
          }]
        }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_van_field, {
          modelValue: $data.form.customerType.text,
          "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => $data.form.customerType.text = $event),
          readonly: "",
          clickable: "",
          required: "",
          name: "customerType",
          label: "客户类型",
          placeholder: "客户类型",
          rules: [{
            required: true,
            message: '请输入客户类型'
          }],
          onClickInput: _cache[16] || (_cache[16] = $event => $options.onPickerSelectClick('customerType'))
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.categoryType.text,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => $data.form.categoryType.text = $event),
          readonly: "",
          clickable: "",
          required: "",
          name: "categoryType",
          label: "客户类别",
          placeholder: "客户类别",
          rules: [{
            required: true,
            message: '请输入客户类别'
          }],
          onClickInput: _cache[18] || (_cache[18] = $event => $options.onPickerSelectClick('categoryType', 'customerCategoryType'))
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.obtainWay.text,
          "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $data.form.obtainWay.text = $event),
          readonly: "",
          clickable: "",
          required: "",
          name: "obtainWay",
          label: "获客方式",
          placeholder: "获客方式",
          rules: [{
            required: true,
            message: '请输入获客方式'
          }],
          onClickInput: _cache[20] || (_cache[20] = $event => $options.onPickerSelectClick('obtainWay', 'customerObtainWay'))
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.email,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.form.email = $event),
          name: "email",
          label: "电子邮箱",
          placeholder: "电子邮箱",
          disabled: $data.isDisabled
        }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_van_field, {
          modelValue: $data.form.buildingId.text,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $data.form.buildingId.text = $event),
          readonly: "",
          clickable: "",
          name: "buildingId",
          label: "居住楼盘",
          placeholder: "居住楼盘",
          rightIcon: $options.getRightIcon('buildingId'),
          onClickInput: _cache[23] || (_cache[23] = $event => $options.onPickerDataSelectClick('buildingId')),
          onClickRightIcon: _cache[24] || (_cache[24] = $event => $options.onRightIconClick('buildingId'))
        }, null, 8, ["modelValue", "rightIcon"]), _createVNode(_component_van_field, {
          modelValue: $data.form.buildingNo,
          "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.form.buildingNo = $event),
          name: "buildingNo",
          label: "楼号",
          placeholder: "楼号"
        }, null, 8, ["modelValue"]), _createVNode(_component_van_field, {
          modelValue: $data.form.importType.text,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.form.importType.text = $event),
          readonly: "",
          clickable: "",
          name: "importType",
          label: "客户重要性",
          placeholder: "客户重要性",
          rules: [{
            required: true,
            message: '请输入客户重要性'
          }],
          onClickInput: _cache[27] || (_cache[27] = $event => $options.onPickerSelectClick('importType', 'customerImportType'))
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_van_divider), _createVNode(_component_van_button, {
        plain: "",
        hairline: "",
        style: {
          "width": "100%"
        },
        type: "primary",
        icon: "plus",
        onClick: _withModifiers($options.onAddAddrItem, ["prevent"])
      }, {
        default: _withCtx(() => [_createTextVNode(" 添加地址 ")]),
        _: 1
      }, 8, ["onClick"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.form.addrs, (addr, addrIndex) => {
        return _openBlock(), _createBlock(_component_van_cell_group, {
          title: "地址信息",
          key: addr.id
        }, {
          title: _withCtx(() => [_createElementVNode("span", null, "地址" + _toDisplayString(addrIndex + 1) + "：", 1), !addr.id ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            type: "danger",
            size: "mini",
            plain: "",
            style: {
              "float": "right"
            },
            onClick: $event => $options.delAddr(addrIndex)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_van_field, {
            modelValue: addr.addressType.text,
            "onUpdate:modelValue": $event => addr.addressType.text = $event,
            readonly: "",
            name: "addressType",
            label: "地址类型",
            placeholder: "地址类型",
            clickable: !$data.isDisabled || !addr.id,
            disabled: $data.isDisabled && !!addr.id,
            required: "",
            rules: [{
              required: true,
              message: '请选择地址类型'
            }],
            onClickInput: $event => $options.onPickerSelectClick('addressType', undefined, `addrs[${addrIndex}].pcc`)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "clickable", "disabled", "onClickInput"]), _createVNode(_component_van_field, {
            modelValue: addr.pcc,
            "onUpdate:modelValue": $event => addr.pcc = $event,
            readonly: "",
            name: "pcc",
            label: "省市区",
            placeholder: "省市区",
            clickable: !$data.isDisabled || !addr.id,
            disabled: $data.isDisabled && !!addr.id,
            required: "",
            rules: [{
              required: true,
              message: '请选择地址省市区'
            }],
            onClickInput: $event => $options.onPickerAddrDataSelectClick(`addrs[${addrIndex}].pcc`)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "clickable", "disabled", "onClickInput"]), _createVNode(_component_van_field, {
            modelValue: $data.form.addrs[addrIndex].street,
            "onUpdate:modelValue": $event => $data.form.addrs[addrIndex].street = $event,
            autosize: "",
            rows: "1",
            type: "textarea",
            name: "street",
            label: "详细地址",
            placeholder: "详细地址",
            required: "",
            disabled: $data.isDisabled && !!addr.id,
            rules: [{
              required: true,
              message: '请输入详细地址'
            }]
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
          _: 2
        }, 1024);
      }), 128)), _createVNode(_component_van_divider), _createVNode(_component_van_button, {
        plain: "",
        hairline: "",
        style: {
          "width": "100%"
        },
        type: "primary",
        icon: "plus",
        onClick: _withModifiers($options.onAddBankItem, ["prevent"])
      }, {
        default: _withCtx(() => [_createTextVNode(" 添加银行账户信息 ")]),
        _: 1
      }, 8, ["onClick"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.form.bankInfo, (item, addrIndex) => {
        return _openBlock(), _createBlock(_component_van_cell_group, {
          title: "银行账户信息",
          key: addrIndex
        }, {
          title: _withCtx(() => [_createElementVNode("span", null, "账户" + _toDisplayString(addrIndex + 1) + "：", 1), !item.id ? (_openBlock(), _createBlock(_component_van_button, {
            key: 0,
            type: "danger",
            size: "mini",
            plain: "",
            style: {
              "float": "right"
            },
            onClick: $event => $options.delBankAcc(addrIndex)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_van_field, {
            modelValue: item.bankName,
            "onUpdate:modelValue": $event => item.bankName = $event,
            name: "bankName",
            label: "开户行",
            placeholder: "开户行",
            required: "",
            clickable: !$data.isDisabled || !item.id,
            disabled: $data.isDisabled && !!item.id,
            rules: [{
              required: true,
              message: '请选择开户行'
            }],
            onClickInput: $event => $options.onpickerDataSelectClickBank('bankId', addrIndex)
          }, null, 8, ["modelValue", "onUpdate:modelValue", "clickable", "disabled", "onClickInput"]), _createVNode(_component_van_field, {
            modelValue: item.branchBankName,
            "onUpdate:modelValue": $event => item.branchBankName = $event,
            name: "accountHolder",
            label: "分行名称",
            placeholder: "分行名称",
            disabled: $data.isDisabled && !!item.id,
            rules: [{
              required: false,
              message: '请输入分行名称'
            }]
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _createVNode(_component_van_field, {
            modelValue: item.accountHolder,
            "onUpdate:modelValue": $event => item.accountHolder = $event,
            autosize: "",
            rows: "1",
            type: "textarea",
            name: "accountHolder",
            label: "开户名",
            placeholder: "开户名",
            required: "",
            disabled: $data.isDisabled && !!item.id,
            rules: [{
              required: true,
              message: '请输入开户名'
            }]
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]), _createVNode(_component_van_field, {
            modelValue: item.cardNo,
            "onUpdate:modelValue": $event => item.cardNo = $event,
            autosize: "",
            rows: "1",
            type: "textarea",
            name: "cardNo",
            label: "开户账号",
            placeholder: "开户账号",
            required: "",
            disabled: $data.isDisabled && !!item.id,
            rules: [{
              required: true,
              message: '请输入开户账号'
            }]
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])]),
          _: 2
        }, 1024);
      }), 128)), _createVNode(_component_van_divider)]),
      _: 1
    }, 8, ["onSubmit"]), _createVNode(_component_CodeDataPickerCpt, {
      ref: "CodeDataPickerCpt",
      onOnSelectedChange: $options.onPickerSelected
    }, null, 8, ["onOnSelectedChange"]), _createVNode(_component_DataPickerCpt, {
      ref: "DataPickerCpt",
      columnsFieldNames: $data.columnsFieldNames,
      onOnSelectedChange: $options.onPickerDataSelected
    }, null, 8, ["columnsFieldNames", "onOnSelectedChange"]), _createVNode(_component_AddrDataPickerCpt, {
      ref: "AddrDataPickerCpt",
      onOnSelectedChange: $options.onPickerAddrDataSelected
    }, null, 8, ["onOnSelectedChange"]), _createVNode(_component_PopupDatePickerCpt, {
      ref: "PopupDateTimeCpt",
      onOnSelectedChange: $options.onDateTimeSelectedChange
    }, null, 8, ["onOnSelectedChange"])]),
    _: 1
  });
}